import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import React, { useState, useEffect } from "react";
import DataService from "../IndexBD/DataService";

function AutoCompleteSm(params) {
  const [value, setValue] = React.useState("");
  const [inputValue, setInputValue] = React.useState("");
  const [datos, setDatos] = React.useState([]);
  const [cliente, setCliente] = React.useState(null);

  useEffect(() => {
    if (params.clientes.length > 0) {
      cargarDatos();
    }
  }, [params.clientes]);

  function cargarDatos() {
    const array = [];
    params.clientes.forEach((element) => {
      let opt = new OptionsAuto(element.cedula, element.nombreCompleto);
      array.push(opt);
    });
    const lista=limpiarYUnificarDatos(array)
    setDatos(lista);
  }

  const filterOptions = createFilterOptions({
        matchFrom: "any",
        limit: 10,
        stringify: (option) => option.label.trim().toLowerCase(),
    });

   const limpiarYUnificarDatos = (arr) => {
        const seen = new Set();
        return arr
            .map((item) => ({
                ...item,
                label: item.label.trim(), // Elimina espacios al inicio y al final
            }))
            .filter((item) => {
                const isDuplicate = seen.has(item.id);
                seen.add(item.id);
                return !isDuplicate;
            });
    };

  function getInputChange(newInputValue) {
    // se ejecuta siempre que hay cambio en el input
    setInputValue(newInputValue);
  }

  function getOnchange(newValue) {
    // Se ejecuta al cambiar un valor del array
    const tipo = typeof newValue;
    if (tipo === "object") {
      if (newValue != null) {
        buscarCliente(newValue.id);
      }
    }
  }

  const buscarCliente = async (cedula) => {
    try {
      const data = await DataService.loadAllData("clientes");
      if (data.length == 0) {
        document.getElementById("btnDescargarDatos").click();
      } else {
        let cliente = null;
        data.forEach((element) => {
          if (element.cedula == cedula) {
            cliente = element;
          }
        });
        setCliente(cliente)
        setTimeout(() => {
          setInputValue("")
          document.getElementById("btnValidarDetalleCliente").click();
        }, 100); 
      }
    } catch (error) {}
  };

  function submitHandler(e) {
    e.preventDefault();
  }

  return (
    <div>
      <button
        style={{ display: "none" }}
        id="btnValidarDetalleCliente"
        onClick={() => params.validarDetalleCliente(cliente)}
      ></button>
      <button
        style={{ display: "none" }}
        id="btnDescargarDatos"
        onClick={params.confirmarFetchPrestamos}
      ></button>
      <form
        style={{ marginLeft: "0.2em", padding: "0.3em" }}
        onSubmit={submitHandler}
        id="formAutocomplete"
        className="form-inline"
      >
        <div className="input-group">
          <Autocomplete
           filterOptions={filterOptions}
            className="rounded"
            style={{ backgroundColor: "white" }}
            disablePortal
            id="combo-box-demo"
            value={value}
            sx={{ width: 340 }}
            renderInput={(params) => (
              <TextField
                id="autoCompleteTF"
                {...params}
                InputLabelProps={{ style: { color: "black" } }}
                label="Buscar cliente..."
                size="small"
              />
            )}
            onChange={(_, newValue) => {
              getOnchange(newValue);
            }}
            inputValue={inputValue}
            onInputChange={(_, newInputValue) => {
              getInputChange(newInputValue);
            }}
            options={datos}
            freeSolo
          />
        </div>
      </form>
    </div>
  );
}

export default AutoCompleteSm;

class OptionsAuto {
  constructor(id, label) {
    this.id = id;
    this.label = label;
  }

  getLabel() {
    return this.label;
  }

  getId() {
    return this.id;
  }
}
